import ApiSubjectsManagement from '../api/subjects-manager';

// Cache for resolved subjects (session-scoped)
const subjectCache = new Map();

export const resolveSubject = async (identifier, projectId) => {
  const cacheKey = `${projectId}:${identifier}`;

  // Check cache first
  if (subjectCache.has(cacheKey)) {
    return subjectCache.get(cacheKey);
  }

  try {
    // Query subjects API
    const response = await ApiSubjectsManagement.getSubjects({
      search: identifier,
      limit: 10
    });

    // Handle both response.data.subjects and response.data.data.subjects
    const subjects = response.data?.data?.subjects || response.data?.subjects || [];

    // Try exact email match first
    let subject = subjects.find(s =>
      s.email?.toLowerCase() === identifier.toLowerCase()
    );

    // If not found, try displayId match
    if (!subject) {
      subject = subjects.find(s =>
        s.displayId?.toLowerCase() === identifier.toLowerCase()
      );
    }

    if (subject) {
      // Cache successful resolution
      subjectCache.set(cacheKey, subject);
      return subject;
    }

    return null;
  } catch (err) {
    console.error('[SubjectResolver] Failed to resolve subject:', err);
    return null;
  }
};

export const clearSubjectCache = () => {
  subjectCache.clear();
};
